import { IRewardData } from '../../Utility/RewardHelper';
import { RewardType } from '../../Utility/Rewards/RewardType';
import { Random } from '../../Utility/Random';

export function getMyPetMiniGameJackpotReward(): IRewardData {
    return {
        type: RewardType.COINS,
        value: 22_000,
        isJackpot: true,
    };
}

const getMyPetMiniGameWeightedRewards: () => Random.IWeightedItem<IRewardData>[] = () => [
    {
        data: getMyPetMiniGameJackpotReward(),
        odds: 0.01,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 1_100,
        },
        odds: 0.15,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 1_650,
        },
        odds: 0.09,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 2_200,
        },
        odds: 0.05,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 2_750,
        },
        odds: 0.04,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 3_300,
        },
        odds: 0.03,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 3_850,
        },
        odds: 0.03,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 4_400,
        },
        odds: 0.02,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 5_500,
        },
        odds: 0.02,
    },
    {
        data: {
            type: RewardType.COINS,
            value: 11_000,
        },
        odds: 0.01,
    },
    {
        data: {
            type: RewardType.FREE_PLAY,
            value: 1,
        },
        odds: 0.13,
    },
    {
        data: {
            type: RewardType.FREE_PLAY,
            value: 2,
        },
        odds: 0.1,
    },
    {
        data: {
            type: RewardType.FREE_PLAY,
            value: 3,
        },
        odds: 0.03,
    },
    {
        data: {
            type: RewardType.BULLSEYE,
            value: 1,
        },
        odds: 0.08,
    },
    {
        data: {
            type: RewardType.BULLSEYE,
            value: 2,
        },
        odds: 0.01,
    },
    {
        data: {
            type: RewardType.PLUS_FIVE_CARDS,
            value: 1,
        },
        odds: 0.11,
    },
    {
        data: {
            type: RewardType.PLUS_FIVE_CARDS,
            value: 2,
        },
        odds: 0.01,
    },
    {
        data: {
            type: RewardType.JOKER,
            value: 1,
        },
        odds: 0.05,
    },
    {
        data: {
            type: RewardType.JOKER,
            value: 2,
        },
        odds: 0.01,
    },
    {
        data: {
            type: RewardType.BOMB,
            value: 1,
        },
        odds: 0.02,
    },
];

export function getRandomPetMinigameRewards(amount: number, blacklistedBoosters?: RewardType[]): IRewardData[] {
    let weightedItems = getMyPetMiniGameWeightedRewards();

    // Filter-out any blacklisted stuffs
    if (blacklistedBoosters && blacklistedBoosters.length > 0) {
        weightedItems = weightedItems.filter(
            (e: Random.IWeightedItem<IRewardData>) => blacklistedBoosters.indexOf(e.data.type) === -1
        );
    }

    const rewards: IRewardData[] = [];

    for (let i = 0; i < amount; i++) {
        const reward = Random.getRandomWeighted(weightedItems);
        rewards.push(reward);
        weightedItems = weightedItems.filter(r => r.data !== reward);
    }

    return rewards;
}
